import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            影视分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            海量影视资源，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 rounded-lg p-5 md:p-8 flex flex-col items-center gap-3 md:gap-4 cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400">
                  {cat.count.toLocaleString()} 部资源
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}